import React from 'react'

import { connect } from 'react-redux'
import { FormattedMessage, injectIntl } from 'react-intl'

import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import * as selectors from '../documents.selectors'
import { Game, Firebase } from '../../../Core'

import SettingsMenuButton from '../../Settings/SettingsMenuButton'
import HelpButton from '../../Settings/HelpButton'
import UserShield from '../../Components/UserShield'

const DOCUMENTS_HOST = process.env.DOCUMENTS_HOST
/**
 *  Pop up showed when you have finished the game
 */
class DocumentsScreen extends React.Component {
  /**
   *  Component constructor.
   */
  constructor(props) {
    super(props)
    this.state = {
      growOutClass: '',
      docs: [],
      activeFolder: false,
    }
  }

  componentDidMount() {
    this.goToFolders()
  }
  closeScreen() {
    const { removeScreen } = this.props
    this.setState({ growOutClass: 'bounceOut-animation' })
    setTimeout(() => removeScreen('documents_screen'), 1000)
  }

  goToFolders() {
    const { docs } = this.props
    this.setState({ docs, activeFolder: false })
  }

  getIconClass(type) {
    switch (type) {
      case 'embedded_video':
        return 'video'
      case 'video':
        return 'video'
      case 'audio':
        return 'audio'
      case 'pdf':
        return 'doc'
      case 'folder':
        return 'file'
    }
  }
  enterFolder(doc, index) {
    const activeFolder = { ...doc, index }
    this.setState({ docs: doc.documents, activeFolder })
  }

  getDocumentUrl(url) {
    if (url && !url.match(DOCUMENTS_HOST)) {
      return DOCUMENTS_HOST + url
    }
    return url
  }

  renderDocumentItem(doc, index) {
    const document = doc.isFolder ? doc : doc.document

    const url = this.getDocumentUrl(document.url)
    return (
      <div
        key={index}
        className="documents--folder__item"
        onClick={() => (document.isFolder ? this.enterFolder(doc, index + 1) : null)}
      >
        <span className={`icon-${this.getIconClass(document.type)}`}> </span>
        <div className="name">
          {url ? (
            <a href={url} target="_blank" rel="noopener noreferrer">
              {document.name}
            </a>
          ) : (
            <span>
              {' '}
              Folder-{index + 1}: {document.isFolder ? document.name : document.name}
            </span>
          )}
        </div>
      </div>
    )
  }

  render() {
    const { currentUser } = this.props
    const { growOutClass, docs, activeFolder } = this.state

    const BackButton = ({ onClick }) => (
      <div className={`position--absolute left top z-index2`}>
        <div onClick={() => onClick()}>
          <div className="btn--back">
            <span className="icon-back"></span>
          </div>
        </div>
      </div>
    )

    return (
      <div
        className={`container ${growOutClass} ${
          !growOutClass ? 'growIn-animation' : ''
        } mina background--mina__canvas z-index2`}
      >
        <UserShield shield={currentUser.colonyShield} />
        <BackButton onClick={() => this.closeScreen()} />
        <div className="mina--layer documents--layer">
          <div className="documents">
            {activeFolder ? (
              <div
                onClick={() => {
                  this.goToFolders()
                }}
                className="documents--subtitle"
              >
                <div className="file--name">
                  <span className="icon-angle-left"> </span>
                  <b>Folder-{activeFolder.index}:</b> {activeFolder.name}{' '}
                </div>
              </div>
            ) : (
              <FormattedMessage
                id="popups.noDocument"
                defaultMessage="Any document available yet"
              />
            )}
            <div className="documents--folder">
              {docs.map((doc, index) => this.renderDocumentItem(doc, index))}
            </div>
          </div>
        </div>
        <SettingsMenuButton />
        <HelpButton />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  docs: selectors.getDocumentsList(state),
  currentUser: Firebase.selectors.getUserData(state),
})

const mapDispatchToProps = (dispatch) => {
  return {
    removeScreen: bindActionCreators(Game.actions.removeScreen, dispatch),
  }
}
DocumentsScreen.propTypes = {
  docs: PropTypes.array,
  removeScreen: PropTypes.func,
  currentUser: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(DocumentsScreen))
